<template>
    <div
        :class="{
            '':
                ($route.name === 'casino-casino-list' && marqueeStatus) ||
                ($route.name === 'casino-games' && marqueeStatus)
        }"
    >
        <div
            v-show="$breakpoint.smAndDown && isDrawerOpen"
            :style="{ height: tabContainerHeight }"
            class="tabs-container"
        >
            <v-tabs
                v-if="$breakpoint.smAndDown"
                v-model="activetab"
                :light="!$vuetify.theme.dark"
                class="menu-tab tab-below"
                :class="{
                    'grey darken-4': $vuetify.theme.dark,
                    'grey lighten-2': !$vuetify.theme.dark
                }"
                :color="$vuetify.theme.dark ? 'white' : 'black'"
                :hide-slider="activeBar"
                grow
                centered
                :height="$breakpoint.mdAndDown ? 64 : 64"
                :icons-and-text="$breakpoint.smAndDown"
            >
                <v-tabs-slider
                    v-if="activetab"
                    :color="domainUrl ? 'red' : 'superBlueClass'"
                ></v-tabs-slider>
                <div
                    v-if="$breakpoint.smAndDown"
                    class="d-flex game-nav px-2 w-100"
                >
                    <v-tab to="/live-cards" class="caption">
                        <v-img
                            contain
                            :src="
                                require(`@/assets/images/menu/Live-Cards.webp`)
                            "
                            height="25"
                            width="50"
                            class="rounded-t-lg justify-content-center"
                            aspect-ratio="1"
                        ></v-img>
                        {{ $t("menu.live_card") }}
                    </v-tab>
                    <v-spacer></v-spacer>
                    <v-tab
                        v-if="fantasyOnOff"
                        to="/fantasybook/Cricket/Inplay"
                        class="caption"
                    >
                        <v-img
                            contain
                            :src="
                                domainUrl
                                    ? require(`@/assets/images/menu/fantasybookicon.webp`)
                                    : require(`@/assets/images/menu/Fantasy.webp`)
                            "
                            height="25"
                            width="50"
                            class="rounded-t-lg justify-content-center"
                            aspect-ratio="1"
                        ></v-img>
                        {{ $t("menu.fantasybook") }}
                    </v-tab>
                    <v-spacer v-if="fantasyOnOff"></v-spacer>
                    <v-tab
                        v-if="
                            !$auth.user ||
                            ($auth.user.casino && !$breakpoint.mdAndUp)
                        "
                        to="/casino"
                        class="caption"
                    >
                        <v-img
                            contain
                            :src="require(`@/assets/images/menu/Casino.webp`)"
                            height="30"
                            width="40"
                            class="rounded-t-lg justify-content-center"
                            aspect-ratio="1"
                        ></v-img>
                        {{ $t("menu.live_casino") }}
                    </v-tab>
                    <v-spacer></v-spacer>
                    <v-tab
                        v-if="
                            (showElection &&
                                $auth.user &&
                                $auth.user.sportsbook) ||
                            (showElection && !$auth.user)
                        "
                        to="/sportsbook/Election"
                        class="caption"
                    >
                        <v-img
                            contain
                            :src="require(`@/assets/images/menu/Election.webp`)"
                            height="30"
                            width="50"
                            class="rounded-t-lg justify-content-center"
                            aspect-ratio="1"
                        >
                        </v-img>
                        Election
                    </v-tab>
                    <v-spacer
                        v-if="
                            (showElection &&
                                $auth.user &&
                                $auth.user.sportsbook) ||
                            (showElection && !$auth.user)
                        "
                    ></v-spacer>
                    <v-tab
                        v-if="
                            !$auth.user ||
                            ($auth.user.casino && $breakpoint.smAndDown)
                        "
                        to="/casino-slots"
                        class="caption px-2 py-1"
                    >
                        <v-img
                            contain
                            :src="
                                require(`@/assets/images/menu/Slot-game.webp`)
                            "
                            height="30"
                            width="45"
                            class="rounded-t-lg justify-content-center"
                            aspect-ratio="1"
                        ></v-img>
                        {{ $t("menu.slot_games") }}
                    </v-tab>
                    <v-spacer
                        v-if="
                            !$auth.user ||
                            ($auth.user.fundist && $breakpoint.smAndDown)
                        "
                    ></v-spacer>
                    <v-tab
                        v-if="
                            !$auth.user ||
                            ($auth.user.fundist && $breakpoint.smAndDown)
                        "
                        to="/live-casino"
                        class="caption caption-mobile px-2"
                        :class="$breakpoint.mdAndUp ? 'py-1 ml-3' : ''"
                    >
                        <v-img
                            contain
                            :src="require(`@/assets/images/menu/fundlist.webp`)"
                            height="35"
                            width="34"
                            class="rounded-t-lg justify-content-center"
                            :class="$breakpoint.mdAndUp ? 'mr-1' : ''"
                            aspect-ratio="1"
                        ></v-img>
                        Crash Games
                    </v-tab>
                </div>
            </v-tabs>
        </div>
        <div
            v-if="$breakpoint.smAndDown"
            class="bottom-arrow"
            @click="toggleDrawer()"
        >
            <v-icon v-if="isDrawerOpen" class="icon-down"
                >mdi-chevron-down</v-icon
            >
            <v-icon v-else class="icon-up">mdi-chevron-up</v-icon>
        </div>
    </div>
</template>


<script>
import { mapState } from "vuex"
import remove from "lodash/remove"

export default {
    name: "NavBar",
    data() {
        return {
            domainUrl: process.env.THEME_BASIC === "true" ? 1 : 0,
            activetab: null,
            menuicon: "iconpe-Hamburger",
            isDrawerOpen: true,
            tabs: {
                mobileItems: [
                    {
                        src: "Inplay",
                        icon: "mdi-play-circle",
                        text: "Inplay",
                        status: true,
                        link: "/"
                    },
                    {
                        src: "Sportsbook",
                        icon: "iconpe-sportsbook",
                        text: "Sports Exch",
                        status: true,
                        link: "/sportsbook"
                    }
                ],
                items: [
                    {
                        src: "Cricket",
                        icon: "iconpe-cricket",
                        text: "Cricket",
                        status: true,
                        link: "/sportsbook/Cricket"
                    },
                    {
                        src: "Soccer",
                        icon: "mdi-soccer",
                        text: "Soccer",
                        status: true,
                        link: "/sportsbook/Soccer"
                    },
                    {
                        src: "Tennis",
                        icon: "iconpe-tennis",
                        text: "Tennis",
                        status: true,
                        link: "/sportsbook/Tennis"
                    }
                ]
            }
        }
    },
    computed: {
        tabContainerHeight() {
            return this.$breakpoint.smAndDown ? "100%" : "calc(100vh - 100px)"
        },
        activeBar() {
            console.log("this.$route.name", this.$route.name)
            return (
                this.$route.name !== "live-cards" &&
                this.$route.name !== "live-cards-id" &&
                this.$route.name !== "live-event" &&
                this.$route.name !== "live-games" &&
                this.$route.name !== "casino-slots" &&
                this.$route.name !== "casino-slots-id" &&
                this.$route.name !== "casino-live-casino" &&
                this.$route.name !== "live-casino" &&
                this.$route.name !== "live-casino-system-pageNo" &&
                this.$route.name !== "live-casino-system" &&
                this.$route.name !== "fantasybook-betfairId-gameType" &&
                this.$route.name !==
                    "fantasybook-match-game-matchType-betfairId-gameType" &&
                this.$route.name !==
                    "fantasybook-match-inner-parentCategory-betfairId-game-gameType-contestId"
            )
        },
        ...mapState({
            maintenanceStatus: (state) => state.maintenance.maintenanceStatus,
            marqueeStatus: (state) => state.notificationMarquee.marqueeStatus,
            isBottomDrawerOpen: (state) =>
                state.notificationMarquee.isBottomDrawerOpen,
            fantasyOnOff: (state) => state.user.fantasyConfig,
            showElection: (state) => state.inplay.showElectionData
        })
    },
    watch: {
        isBottomDrawerOpen() {
            this.isDrawerOpen = this.isBottomDrawerOpen
        },
        showElection() {
            return JSON.parse(localStorage.getItem("showElectionData"))
        }
    },
    mounted() {
        this.$store.commit("notificationMarquee/set_isBottomDrawerOpen", true)
        if (this.$auth.loggedIn) {
            this.activeGames()
        }
    },
    created() {
        this.$store.commit(
            "inplay/set_election_data",
            JSON.parse(localStorage.getItem("showElectionData"))
        )
    },
    methods: {
        toggleDrawer() {
            this.isDrawerOpen = !this.isDrawerOpen
            this.$store.commit(
                "notificationMarquee/set_isBottomDrawerOpen",
                this.isDrawerOpen
            )
        },
        activeGames() {
            this.tabs.items = remove(this.tabs.items, (game) => {
                if (
                    this.$auth.user.sportsbook &&
                    (game.text === "Cricket" ||
                        game.text === "Soccer" ||
                        game.text === "Tennis" ||
                        game.text === "Inplay")
                ) {
                    return game
                } else if (
                    this.$auth.user.casino &&
                    game.text === "Live Casino"
                ) {
                    return game
                } else if (
                    this.$auth.user.cardgame &&
                    game.text === "Live Card"
                ) {
                    return game
                } else if (
                    this.$auth.user.casino &&
                    game.text === "Slot Games"
                ) {
                    return game
                } else if (
                    this.$auth.user.election &&
                    game.text === "Election"
                ) {
                    return game
                } else if (this.$auth.user && game.text === "Horse Racing") {
                    return game
                } else if (this.$auth.user && game.text === "fundist") {
                    return game
                } else if (
                    this.$auth.user.premiumsportsbook &&
                    game.text === "Premium Sportsbook"
                ) {
                    return game
                } else if (
                    this.$auth.user &&
                    this.$auth.user.horseRacing &&
                    this.domain === "playtowin.club" &&
                    game.text === "Horse Racing"
                ) {
                    return game
                }
            })
            this.tabs.mobileItems = remove(this.tabs.mobileItems, (game) => {
                if (
                    this.$auth.user.sportsbook &&
                    (game.text === "Sports Exch" || game.text === "Inplay")
                ) {
                    return game
                } else if (
                    this.$auth.user.casino &&
                    game.text === "Live Casino"
                ) {
                    return game
                } else if (
                    this.$auth.user.cardgame &&
                    game.text === "Live Card"
                ) {
                    return game
                } else if (
                    this.$auth.user.casino &&
                    game.text === "Slot Games"
                ) {
                    return game
                } else if (
                    this.$auth.user.election &&
                    game.text === "Election"
                ) {
                    return game
                } else if (
                    this.$auth.user.cardgame &&
                    game.text === "Horse Racing"
                ) {
                    return game
                } else if (
                    this.$auth.user.premiumsportsbook &&
                    game.text === "Premium Sportsbook"
                ) {
                    return game
                }
            })
        }
    }
}
</script>

<style lang="scss">
$primary: var(--v-primary-base);
.premium-topbar .menu-tab .spacer {
    background-color: gray;
    flex-grow: 0 !important;
    height: 100%;
    margin: 0.5rem 0;
    width: 1px;
}
.superBlueClass {
    background-color: var(--v-superBlue-base);
    border-color: var(--v-superBlue-base);
    width: 60%;
    margin: 0 auto;
    margin-bottom: 2rem;
}
.premium-topbar {
    .menu-tab {
        .v-item-group {
            padding-bottom: 0.4rem;
        }
        .v-tabs-slider-wrapper {
            display: block !important;
        }
    }
    .v-tabs-slider {
        width: 60%;
        color: red;
        margin: 0 auto 2rem;
    }
}
.v-tabs--icons-and-text > .v-tabs-bar .v-tab > *:first-child {
    margin-bottom: 0px !important;
}
.tabs-container {
    overflow-y: auto;
}
.br-lr {
    position: relative;
    &:before,
    &:after {
        // content: '';
        position: absolute;
        background-color: gray;
        width: 1px;
        padding: 1.5rem 0;
        opacity: 1;
    }
    &:after {
        right: 0;
    }
    &:before {
        left: 0;
        right: auto !important;
        bottom: inherit;
        top: inherit;
    }
}
</style>
<style lang="scss" scoped>
.v-tabs--icons-and-text > .v-tabs-bar .v-tab {
    border-right: 0px;
}
.bottom-arrow {
    i {
        position: fixed;
        right: 0;
        // left: 50%;
        &::before {
            background: linear-gradient(to top, #4caf50 50%, #4caf50 100%);
            border-top-right-radius: 5px;
            border-top-left-radius: 5px;
            font-size: 22px;
        }
        z-index: 200000000; /* Set a high z-index value to make sure it's above other elements */
    }
    .icon-down {
        bottom: 64px;
    }
    .icon-up {
        bottom: 0px;
    }
}
@media (min-width: 768px) {
    .bottom-arrow {
        i {
            &::before {
                font-size: 32px;
            }
        }
    }
}
</style>
